import styled from '@emotion/styled'

export const Constraint = styled.div`
  ${props => props.width && `max-width: ${props.width}px`};
  ${props => props.height && `max-height: ${props.height}px`};
  ${props => props.centered && `margin: auto`};
`
